import { Button, Card } from "react-bootstrap";
import type { Banner } from "@services/banners/commands/cmdListBanners";
import MarketingBanner from "@/shared/components/MarketingBanner/MarketingBanner";
import { liveWindowLabel } from "@/shared/utils/date-utils/easternTime";

interface LiveNowCardProps {
    banner: Banner | undefined;
    onEdit: (banner: Banner) => void;
    onTurnOff: (banner: Banner) => void;
}

export default function LiveNowCard({ banner, onEdit, onTurnOff }: LiveNowCardProps) {
    return (
        <Card className="banners-page__card">
            <Card.Body>
                <h2 className="banners-page__card-title">Live Now</h2>
                {banner ? (
                    <>
                        <div className="banners-page__banner-frame">
                            <MarketingBanner message={banner.message} linkText={banner.link_text} linkUrl={banner.link_url} />
                        </div>
                        <div className="banners-page__live-row">
                            <span className="banners-page__live-line">{liveWindowLabel(banner)}</span>
                            <div className="d-flex gap-2">
                                <Button variant="neutral" onClick={() => onEdit(banner)}>Edit</Button>
                                <Button variant="danger" onClick={() => onTurnOff(banner)}>Turn Off</Button>
                            </div>
                        </div>
                    </>
                ) : (
                    <p className="banners-page__empty fst-italic text-muted mb-0">
                        No banner is live. Clients see the Partner Dashboard with no banner.
                    </p>
                )}
            </Card.Body>
        </Card>
    );
}
